import { Link } from 'react-router-dom'

/** Texto padrão de aceite de Política de Privacidade e Termos de Uso. */
const LegalConsentText = ({ onLinkClick, className = '' }) => (
  <span className={className}>
    Li e concordo com a{' '}
    <Link
      to="/privacidade"
      onClick={onLinkClick}
      className="text-accent font-semibold hover:underline focus:outline-none rounded"
    >
      Política de Privacidade
    </Link>{' '}
    e os{' '}
    <Link
      to="/termos"
      onClick={onLinkClick}
      className="text-accent font-semibold hover:underline focus:outline-none rounded"
    >
      Termos de Uso
    </Link>
    .
  </span>
)

export default LegalConsentText
